import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { omit, formatSymbolsMap, toArray, formatPrecision, getQuoteTokenSymbols, getQuoteTokenSymbolsMap } from './utils/tools';

/**
 * 对现货交易对做逻辑上的处理，处理为符合现货交易的逻辑
 * 抽离现货交易站 store/setting里的GET_SYMBOLS方法，导出给现货、期货、期权或其他应用自行调用，统一处理现货交易对信息；
 * @param {Object} result symbol_list返回的交易对源数据
 * @return {Object} 返回处理后的交易对数据
 */
var handleSymbols = function handleSymbols(result) {
  // 计价货币列表
  var totalCurrencys = [];

  // 计价货币（交易区）列表，不含法币
  var quoteCurrencys = [];

  // 处理后的交易对列表
  var symbols = [];

  // 交易区标签
  var quoteTags = {};

  // 所有法币列表
  var allFiatCurrency = [];

  // 计价货币为法币的列表
  var fiatCurrency = [];

  // 计价货币信息（比如USDT的图标之类的）
  var qouteTokenInfo = {};

  // 获取币对处理后的结果
  var getSymbolsResult = function getSymbolsResult() {
    return {
      symbols: symbols,
      symbolMap: formatSymbolsMap(symbols),
      quoteTags: quoteTags,
      totalCurrencys: totalCurrencys,
      quoteCurrencys: quoteCurrencys,
      allFiatCurrency: allFiatCurrency,
      fiatCurrency: fiatCurrency,
      qouteTokenInfo: qouteTokenInfo
    };
  };
  try {
    toArray(result, {
      ignoreNull: true
    }).forEach(function (item) {
      // 修正数据
      item.quoteTokenSymbols = toArray(item.quoteTokenSymbols, {
        ignoreNull: true
      });
      item.quoteTags = toArray(item.quoteTags, {
        ignoreNull: true
      });
      qouteTokenInfo[item.tokenId] = omit(item, ['quoteTokenSymbols', 'quoteTags']);

      // 所有法币集合
      if (item.tokenType === 'REAL_MONEY' && !allFiatCurrency.includes(item.tokenName)) {
        allFiatCurrency.push(item.tokenName);
      }

      // 交易对
      item.quoteTokenSymbols.forEach(function (symbol) {
        // 修正数据
        symbol.tags = toArray(symbol.tags, {
          ignoreNull: true
        });
        symbol.baseTokenName = symbol.baseTokenName.toUpperCase();
        symbol.quoteTokenName = symbol.quoteTokenName.toUpperCase();

        // 生成计价货币列表
        if (!totalCurrencys.find(function (currency) {
          return currency.value === item.tokenName;
        })) {
          totalCurrencys.push({
            value: item.tokenName,
            // 特殊标签类型：0：无；1：零费率；2：NEW；3：HOT
            iconType: item.zeroFeeType || 0
          });
        }

        // 生成计价货币（交易区）列表，不含法币
        if (item.tokenType !== 'REAL_MONEY' && !quoteCurrencys.find(function (currency) {
          return currency.value === item.tokenName;
        })) {
          quoteCurrencys.push({
            value: item.tokenName,
            // 特殊标签类型：0：无；1：零费率；2：NEW；3：HOT
            iconType: item.zeroFeeType || 0
          });
        }

        // 生成计价货币为法币的列表
        if (item.tokenType === 'REAL_MONEY') {
          if (!fiatCurrency.find(function (currency) {
            return currency.value === item.tokenName;
          })) {
            fiatCurrency.push({
              value: item.tokenName,
              // 特殊标签类型：0：无；1：零费率；2：NEW；3：HOT
              iconType: symbol.zeroFeeType || 0 // 是否显示特殊标签
            });
          }

          symbol.isFiat = true;
        }

        // 重新覆盖交易对数据
        symbols.push(_objectSpread(_objectSpread({}, symbol), {}, {
          quantityPrecision: formatPrecision(symbol.basePrecision),
          // 数量精度
          pricePrecision: formatPrecision(symbol.minPricePrecision),
          // 价格精度
          amountPrecision: formatPrecision(symbol.quotePrecision) // 交易额精度
        }));
      });

      // 交易区标签
      item.quoteTags.forEach(function (tag) {
        item.quoteTokenSymbols.some(function (symbol) {
          var _quoteTags$symbol$quo;
          if (symbol.tags.includes(tag) && !((_quoteTags$symbol$quo = quoteTags[symbol.quoteTokenName]) === null || _quoteTags$symbol$quo === void 0 ? void 0 : _quoteTags$symbol$quo.includes(tag))) {
            if (quoteTags[symbol.quoteTokenName]) {
              quoteTags[symbol.quoteTokenName].push(tag);
            } else {
              quoteTags[symbol.quoteTokenName] = [tag];
            }
            return true;
          }
          return false;
        });
      });
    });
    return getSymbolsResult();
  } catch (error) {
    return getSymbolsResult();
  }
};

/**
 * 处理交易对数据
 * @param {Array} data 交易对数据
 * @return {Object} 返回处理后的交易对数据
 * all: 所有交易对数据
 * symbols: 所有quoteTokenSymbols数据
 * symbolsMap: quoteTokenSymbols映射
 * handleSymbols: 处理交易对逻辑的方法
 */
var processSymbolData = function processSymbolData(data) {
  return {
    all: data,
    symbols: getQuoteTokenSymbols(data),
    symbolsMap: getQuoteTokenSymbolsMap(data),
    handleSymbols: handleSymbols
  };
};
export default processSymbolData;